import React, { useState, useEffect } from "react"
import DesktopNav from "./DesktopNav"
import MobileNav from "./MobileNav"

const Navigation = () => {
  // https://www.gatsbyjs.com/docs/debugging-html-builds/
  // https://www.tannerlanglinais.com/blog/gatsby-window-is-not-defined
  const useViewport = () => {
    let mobileBreakpoint = 1000
    const [width, setWidth] = useState(
      typeof window !== "undefined" ? window.innerWidth : mobileBreakpoint
    )
    const [height, setHeight] = useState(
      typeof window !== "undefined" ? window.innerHeight : mobileBreakpoint
    )

    useEffect(() => {
      const handleWindowResize = () => {
        setWidth(window.innerWidth)
        setHeight(window.innerHeight)
      }

      window.addEventListener("resize", handleWindowResize)

      return () => window.removeEventListener("resize", handleWindowResize)
    }, [])

    return { width, height }
  }

  const { width } = useViewport()
  const breakpoint = 1000
  return <>{width < breakpoint ? <MobileNav /> : <DesktopNav />}</>
}

export default Navigation
